<template>
  <div>
    <div class="row">
      <div class="col_12">
        <div class="card no_border">
          <div class="card-header">
            <div class="card-title">{{ $t('sidebar.fileDownload.download') }}</div>
          </div>
          <div class="card-body pl_0 pr_0">
            <div class="row">
<!--              <div class="col_2">
                <div class="form-group ">
                  <label>{{ $t('common.status') }}</label>
                  <div class="d_flex_start">
                    <div class="dropdown custom_dropdown mr_10">
                      <button class="btn">
                        <span>{{ filter2.status }}</span>
                      </button>
                      <div class="dropdown_menu">
                        <ul>
                          <li><a role="button" @click="changeStatusFilter('all')">{{ $t('common.all') }}</a></li>
                          <li><a role="button" @click="changeStatusFilter(1)">{{ $t('common.active') }}</a></li>
                          <li><a role="button" @click="changeStatusFilter(0)">{{ $t('common.inactive') }}</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>-->
              <div class="col_10">
                <div class="form-group ">
                    <label></label>
                    <div class="d_flex_end">
                        <div class="form_row_inline">
                            <input type="text" class="form_global" :placeholder="$t('common.search')" v-model="queryParams.search">
                        </div>
                        <div class="form_row_inline ml_10">
                            <div class="btn btn_common_type_2 width_150p" @click="searchQuery()">{{ $t('common.search') }}</div>
                            <div class="btn btn_common_type_2 width_150p ml_10" @click="resetAll()">{{ $t('common.reset') }}</div>
                        </div>
                    </div>
                </div>
              </div>
            </div>
            <div class="row">
                <div class="col_12 ">
                    <div class="separator pl_0 pr_0">
                        <span></span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col_12">
                    <div class="d_flex_btwn pt_20 pb_20">
                      <div class="d_flex_start col_2 pl_0">
                        <div class="dropdown custom_dropdown mr_10">
                          <button class="btn">
                              <span>{{ filter.per_page }}</span>
                          </button>
                          <div class="dropdown_menu">
                            <ul>
                              <li @click="changeFilter(10)"><a role="button">10</a></li>
                              <li @click="changeFilter(20)"><a role="button">20</a></li>
                              <li @click="changeFilter(50)"><a role="button">50</a></li>
                              <li @click="changeFilter(100)"><a role="button">100</a></li>
                              <li @click="changeFilter(200)"><a role="button">200</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="d_flex_end col_6 pr_0">
                        <router-link :to="{ name: 'download_add'}" class="add_new cursor_pointer btn btn_transparent">+ {{ $t('sidebar.fileDownload.addFile') }}</router-link>
                      </div>
                    </div>
                </div>
            </div>

            <table-component 
              :columns="columns"
              :rows="testLectures"
              :pagination="pagination"
              @sorting="sorting"
              :sortable="sortable"
              @pageChanged="pageChanged">
              <template #action="{ row }">
                <div class="d_flex_center table_action_btn">
                  <router-link :to="{name: 'download_edit', params:{id: row.id}}" :title="$t('common.edit')" class="btn btn_blue ml_10">
                    <img :src="`${baseUrl}assets/media/images/icon/8.png`" alt="">
                  </router-link>
                  <button class="btn btn_danger ml_10" :title="$t('common.delete')" @click.prevent="deleteRecord(row)">
                    <img :src="`${baseUrl}assets/media/images/icon/9.png`" alt="">
                  </button>
                </div>
              </template>
            </table-component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
  import TableComponent from "@/components/shared/TableComponent";
  export default {
    components: {TableComponent},
    data() {
      return {
        baseUrl: process.env.VUE_APP_BASE,
        testLectures: [],
        filter: {
            status: '',
            per_page: 20
        },
        filter2: {
          status: this.$t('common.all'),
        },
        queryParams: {
          page: 1,
          search: '',
          search_columns: 'title',
          sort: 'created_at',
          sort_order: 'desc',
          per_page: 20
        },
        pagination: null,
        sortable: {
          order: 'created_at',
          sort: 'desc'
        },
        columns: [
          {
            label: this.$t('sidebar.fileDownload.title'),
            field: "title",
            sortable: false
          },
          {
            label: this.$t('sidebar.fileDownload.grade'),
            field: "grade.name",
            sortable: false
          },
          {
            label: this.$t('sidebar.fileDownload.semester'),
            field: "semester.name",
            sortable: false
          },
          {
            label: this.$t('common.action'),
            field: 'action',
            sortable: false,
            slot: true,
          }
        ],
      }
    },
    watch: {
      $route(to, from) {
          if(to.name == from.name && !window._.isEqual(to, from)){
            this.setQueryData(this.getAllQueryParams())
            this.loadData()
          }
        },
    },
    created() {
      const query = this.getAllQueryParams()
      if(query.page){
        this.setQueryData(query)
      }
  
      this.loadData();
    },
    methods: {
      setQueryData(query){
        this.queryParams = {
          page: query.page,
          search: query.search,
          search_columns: query.search_columns,
          sort: query.sort,
          sort_order: query.sort_order,
          per_page: query.per_page
        }
  
        this.filter = {
          status: query.status,
          per_page: query.per_page
        }
        this.sortable = {
          order:  query.sort,
          sort: query.sort_order
        }
      },
      resetAll(){
        this.sortable = {
          order: 'created_at',
          sort: 'desc'
        }
        this.filter = {
          status: '',
          per_page: 20
        }

        this.filter2 = {
          status: this.$t('common.all')
        }
  
        this.queryParams = {
            page: 1,
            search: '',
            search_columns: 'title',
            sort: 'created_at',
            sort_order: 'desc',
            per_page: 20
        }
  
        this.changeRoute();
        this.loadData();
      },
      searchQuery(){
          this.changeRoute();
      },
      sorting({column, order}) {
          this.queryParams.sort = column;
          this.queryParams.sort_order = order;
          this.queryParams.page = 1;
          this.changeRoute()
      },
      pageChanged(page) {
        this.queryParams.page = page;
        this.changeRoute()
      },
      changeStatusFilter(status){
        if(status == 'all'){
          this.filter.status = ''
          this.filter2.status = this.$t('common.all')
        }else if(status == 1){
          this.filter.status = 1
          this.filter2.status = this.$t('common.active')
        }else{
          this.filter.status = 0
          this.filter2.status = this.$t('common.inactive')
        }
        this.changeRoute();
      },
      changeFilter(per_page){
        this.filter.per_page = per_page
        this.changeRoute();
      },
      changeRoute() {
        this.$router.push({name: this.$route.name, query: {...this.queryParams, ...this.filter}})
      },
      loadData() {
        this.axios.get('/file-downloads', {
              params: {...this.queryParams, ...this.filter}
          }).then((response) => {
              this.testLectures = response.data.data;
              this.pagination = response.data.meta;
          })
      },
      deleteRecord(row) {
        this.$swal({
          title: this.$t('common.deleteConfirmation'),
          text: this.$t('common.warning'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('common.yesDelete'),
          cancelButtonText: this.$t('common.noCancel'),
          confirmButtonColor: '#dd4b39',
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {
            this.axios.delete('/file-downloads/'+row.id).then(() => {
              this.loadData();
              this.$swal.fire(
                this.$t('common.deleted'),
                this.$t('common.deleteMessage'),
                'success'
              )
            });
          }
        });
      },
    }
  }
  </script>
  
  <style scoped>
    .search_btn{
      padding: 10px 10px 10px 15px;
      margin: 0px 10px 0px 0px;
    }
  
    .reset_btn{
      padding: 10px 10px 10px 15px;
    }
  </style>